import { render, staticRenderFns } from "./DamageRequestDetail.vue?vue&type=template&id=1e0848b6&"
import script from "./DamageRequestDetail.vue?vue&type=script&lang=js&"
export * from "./DamageRequestDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports